<template>
  <div class="container">
    <section>
      <ul class="content">
        <li v-for="(item, k) in setList" :key="k">
          <div>
            <label><strong>*</strong>属性名：</label>
            <a-input
              style="width: 120px; margin-right: 10px"
              v-model="item.name"
            />
            <a-icon
              @click="addOrder(item, k)"
              v-show="item.txt == '增加'"
              style="color: #67c23a"
              type="plus-circle"
            />
            <a-icon
              @click="addOrder(item, k)"
              v-show="item.txt == '删除'"
              style="color: #f56c6c"
              type="minus-circle"
            />
          </div>
          <div>
            <label>状态：</label>
            <a-radio-group v-model="item.status">
              <a-radio :value="1">开启</a-radio>
              <a-radio :value="2">关闭</a-radio>
            </a-radio-group>
          </div>
        </li>
        <li class="btnStyle">
          <a-button type="primary" @click="onSubmit">提交</a-button>
        </li>
      </ul>
    </section>
  </div>
</template>
<script>
import moment from "moment";
import axios from "axios";
export default {
  data() {
    return {
      setList: [
        {
          name: "",
          status: 1,
          txt: "增加"
        }
      ],
      details: {}
    };
  },
  props: {
    editDetail: {}
  },
  watch: {
    editDetail() {
      this.getDetails();
    }
  },
  mounted() {
    if (this.editDetail != undefined) {
      this.getDetails();
    }
  },
  methods: {
    getDetails() {
      this.setList = [];
      this.details = this.editDetail;
      if (
        this.details.float_data_config != "" &&
        this.details.float_data_config != undefined
      ) {
        this.details.float_data_config.forEach((item, index) => {
          this.setList.push({
            name: item.name,
            status: item.status,
            txt: index == 0 ? "增加" : "删除"
          });
        });
      } else {
        this.setList = [
          {
            name: "",
            status: 1,
            txt: "增加"
          }
        ];
      }
    },
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          current_page: 1,
          per_page: 100000,
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 4
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    addOrder(val, index) {
      if (val.txt == "增加") {
        this.setList.push({
          name: "",
          status: 1,
          txt: "删除"
        });
      } else {
        this.setList.splice(index, 1);
      }
    },
    verify() {
      let fls = true;
      this.setList.forEach(item => {
        if (item.name == "") {
          fls = false;
          this.$message.warning("请输入属性名");
          return fls;
        }
      });
      return fls;
    },
    onSubmit() {
      let fls = this.verify();
      if (fls) {
        let list = this.setList;
        list.forEach(item => {
          delete item.txt;
        });
        let url =
          this.httpsBasic.url +
          this.httpsBasic.retail +
          "Retail_config/setData";
        let params = {
          token: window.localStorage.getItem("xnwfPcToken"),
          id: this.details.id,
          float_data: JSON.stringify(list)
        };
        // console.log(params);
        axios.post(url, params).then(res => {
          if (res.data.code == 200) {
            this.$message.success("提交成功");
            this.$emit("hideInEdit", false);
          }
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  margin: 50px 6%;
  .content {
    > li {
      > div {
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        label {
          // font-size: 14px;
          strong {
            display: inline-block;
            color: #f56c6c;
            margin-right: 4px;
            font-style: normal;
          }
        }
        i {
          display: inline-block;
          padding: 10px;
          font-size: 30px;
        }
      }
    }
    .btnStyle {
      margin: 60px 80px 0;
    }
  }
}
</style>
